// window.AuthBridge is the Zero Flutter WebView's bridge (also what index.html stamps body.flutter-webview from).
export function isFlutterWebView(): boolean {
  const win = window as unknown as { AuthBridge?: { postMessage?: unknown } };
  return typeof win.AuthBridge?.postMessage === 'function';
}

// The Flutter app passes its safe-area insets as query params.
export function readSafeAreaInset(name: 'safeAreaTop' | 'safeAreaBottom'): number {
  const value = Number(new URLSearchParams(window.location.search).get(name) || 0);
  return Number.isFinite(value) && value > 0 ? value : 0;
}
